export const VALID_AS_OF_DATE = "Jun 1, 2026";

export function validAsOfLabel() {
  return `Valid as of ${VALID_AS_OF_DATE}`;
}
